namespace Gamification.Gamification {

    enum AmbitoEnum {
        Indefinito = 0,
        VisualizzaRisorse = 1,
        VisualizzaProdotti = 2
    }

    @Serenity.Decorators.registerEditor('Gamification.Gamification.ProdottiRisorse2Editor')
    export class ProdottiRisorse2Editor extends Serenity.EntityGrid<ProdottiRisorseRow, any> {
        protected getColumnsKey() { return ProdottiRisorseColumns.columnsKey; }
        protected getDialogType() { return ProdottiRisorseDialog; }
        protected getIdProperty() { return ProdottiRisorseRow.idProperty; }
        protected getInsertPermission() { return ProdottiRisorseRow.insertPermission; }
        protected getLocalTextPrefix() { return ProdottiRisorseRow.localTextPrefix; }
        protected getService() { return ProdottiRisorseService.baseUrl; }

        static AmbitoEnum = AmbitoEnum;

        constructor(container: JQuery) {
            super(container);
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 100;
            return opt;
        }

        protected getInitialTitle() {
            return null;
        }

        protected usePager() {
            return true;
        }

        protected createQuickSearchInput() { }

        protected getGridCanLoad() {
            return this.idProdotto != null || this.idRisorsa != null;
        }

        protected getColumns() {
            var columns = super.getColumns();

            // Add column
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            // Remove Button
            //buttons.splice(Q.indexOf(buttons, x => x.cssClass == "refresh-button"), 1);
            if (Q.Authorization.hasPermission("Role:Admin")) {
                //Add a Button
                buttons.push({
                    title: 'Seleziona',
                    hint: '',
                    cssClass: 'goto-seleziona',
                    icon: 'fa-list-ol',
                    separator: true,
                    onClick: () => { /*Add Function Here */
                        if (this.ambito == AmbitoEnum.VisualizzaRisorse) {
                            //
                            var assetEsperienzePickerDialog = new RisorsePickerDialog({
                                hideRisorse: this.view.getItems().map(x => x.IdProdotto)
                            });
                            //
                            assetEsperienzePickerDialog.onSuccess = (selected) => {
                                // filter already existing products
                                selected = selected.filter(x => !Q.any(this.view.getItems(), y => y.IdRisorsa == x.IdRisorsa));

                                for (var sel of selected) {
                                    var item = <ProdottiRisorseRow>{
                                        IdProdotto: this.idProdotto,
                                        IdRisorsa: sel.IdRisorsa
                                        //,FaseTitolo: sel.Titolo
                                    };

                                    ProdottiRisorseService.Create({
                                        Entity: item
                                    },
                                        response => {
                                            this.view.addItem({
                                                IdProdottoRisorsa: response.EntityId,
                                                IdProdotto: this.idProdotto,
                                                IdRisorsa: sel.IdRisorsa,
                                                IdRisorsaNome: sel.Nome
                                            });
                                            //
                                            this.refresh();
                                        },
                                        {
                                            async: false
                                        });
                                }

                                return true;
                            };
                            //
                            assetEsperienzePickerDialog.dialogOpen();
                        }
                        if (this.ambito == AmbitoEnum.VisualizzaProdotti) {

                            var prodottiClassiPickerDialog = new ProdottiPickerDialog({
                                hideProdotti: this.view.getItems().map(x => x.IdProdotto)
                            });

                            prodottiClassiPickerDialog.onSuccess = (selected) => {
                                selected = selected.filter(x => !Q.any(this.view.getItems(), y => y.IdProdotto == x.IdProdotto));

                                for (var sel of selected) {
                                    var item = <ProdottiRisorseRow>{
                                        IdRisorsa: this.idRisorsa,
                                        IdProdotto: sel.IdProdotto,
                                        //IdProdottoNome: sel.Nome
                                    };

                                    ProdottiRisorseService.Create({
                                        Entity: item
                                    },
                                        response => {
                                            this.view.addItem({
                                                IdProdottoRisorsa: response.EntityId,
                                                IdRisorsa: this.idRisorsa,
                                                IdProdotto: sel.IdProdotto,
                                                IdProdottoNome: sel.Nome
                                            });
                                            //
                                            this.refresh();
                                        },
                                        {
                                            async: false
                                        });
                                }

                                return true;
                            };

                            prodottiClassiPickerDialog.dialogOpen();
                        }
                    }
                });
            }

            //
            return buttons;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);

            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented())
                return;

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Desideri eliminare il record selezionato?', () => {
                        ProdottiRisorseService.Delete({
                            EntityId: item.IdProdottoRisorsa
                        },
                            response => {
                                this.view.deleteItem(item.IdProdottoRisorsa);
                                this.refresh();
                            },
                            { async: false });
                    });
                }

                if (target.hasClass("Risorsa-link")) {
                    e.preventDefault();
                    //
                    new Gamification.RisorseDialog().loadByIdAndOpenDialog(item.IdRisorsa);
                }
                else if (target.hasClass("Prodotto-link")) {
                    e.preventDefault();
                    //
                    new Gamification.ProdottiDialog().loadByIdAndOpenDialog(item.IdProdotto);
                }
            }
        }

        // +++++++++++++++++++++++++++++++++++++++++++
        private _ambito: AmbitoEnum = AmbitoEnum.Indefinito;
        private _idProdotto: number;
        private _idRisorsa: number;

        // +++++++++++++++++++++++++++++++++++++++++++
        get ambito() {
            return this._ambito;
        }

        set ambito(value: AmbitoEnum) {
            if (this._ambito != value) {
                this._ambito = value;

                if (this._ambito == AmbitoEnum.VisualizzaRisorse) {
                    var columns = this.slickGrid.getColumns();

                    var nIndice = Q.indexOf(columns, x => x.field == ProdottiRisorseRow.Fields.IdProdottoNome);
                    columns.splice(nIndice, 1);

                    this.slickGrid.setColumns(columns);
                }

                if (this._ambito == AmbitoEnum.VisualizzaProdotti) {
                    var columns = this.slickGrid.getColumns();

                    var nIndice = Q.indexOf(columns, x => x.field == ProdottiRisorseRow.Fields.IdRisorsaNome);
                    columns.splice(nIndice, 1);

                    this.slickGrid.setColumns(columns);
                }
            }
        }

        // +++++++++++++++++++++++++++++++++++++++++++
        get idRisorsa() {
            return this._idRisorsa;
        }

        set idRisorsa(value: number) {
            if (this._idRisorsa != value) {
                this._idRisorsa = value;
                this.setEquality(ProdottiRisorseRow.Fields.IdRisorsa, value);
                this.refresh();
            }
        }

        // +++++++++++++++++++++++++++++++++++++++++++
        get idProdotto() {
            return this._idProdotto;
        }

        set idProdotto(value: number) {
            if (this._idProdotto != value) {
                this._idProdotto = value;
                this.setEquality(ProdottiRisorseRow.Fields.IdProdotto, value);
                this.refresh();
            }
        }
    }
}